import gql from 'graphql-tag';
import { Mutation, Query, QueryRegistry } from 'core';

/* Only creates a manufacturer in Dgraph, no associated initaitive/space is created */
const CREATE_MANUFACTURER_PROFILE = gql`
  mutation createManufacturer($input: CreateManufacturerProfileInput!) {
    createManufacturerProfile(input: $input) {
      id
    }
  }
`;

export class CreateManufacturerProfileMutation extends Mutation {
  static conf = {
    GQL: CREATE_MANUFACTURER_PROFILE,
    inputName: ['input'],
    resultPath: 'createManufacturerProfile',
  };
}

// initiative 'title' fails -- federated initiative returns no title etc

const MANUFACTURERS = gql`
  query manufacturers(
    $first: Int
    $offset: Int
    $sortField: String
    $sortOrder: SortOrder
    $filters: [FilterInput!]
  ) {
    manufacturers(
      first: $first
      offset: $offset
      sortField: $sortField
      sortOrder: $sortOrder
      filters: $filters
    ) {
      nodes {
        id
        companyName
      }
    }
  }
`;

export class ManufacturersQuery extends Query {
  static conf = {
    GQL: MANUFACTURERS,
    resultPath: 'manufacturers.nodes',
    varNames: ['first', 'offset', 'sortField', 'sortOrder', 'filters'],
  };
}

QueryRegistry.add('manufacturer.ManufacturersQuery', ManufacturersQuery);
